import { areDisplayAdsEnabled } from './adsUtilities';
import { getNativeAdEnabledOrNotFromUserProperties } from './nativeAdsUtils';

export default function areAdsEnabled() {
    return areDisplayAdsEnabled() || getNativeAdEnabledOrNotFromUserProperties(false);
}
